import { HttpResult } from 'widgets-for-react'
import { Acf } from './types_and_parser/types.mod'
import { ExtraImages } from '../public_site/utils/extra_images.mod'
import { ImageSize as PublicSiteImageSize } from './../cms/blocks/types.gen'
import { WordPress } from './wordpress_api'

export const getVacancies = async (howMany?: number): Promise<HttpResult<VacancyResponse[]>> => {

  let fetchUrl = howMany ? `/wp-json/wp/v2/vacancies?per_page=${howMany.toString()}` : '/wp-json/wp/v2/vacancies'
  
  try {
    let vacancies: VacancyResponse[] = await (await fetch(fetchUrl, { credentials: "include" })).json()
    
    let sortedVacancies = vacancies.sort((a, b) => b.date.localeCompare(a.date))

    return {
      kind: 'result',
      status: 200,
      value: sortedVacancies
    }

  } catch (e) {
    console.error(e)

    return { 
      kind: 'failed',
       status: 500
    }
  }
}

export interface VacancyResponse extends WordPress.PostResponse<'vacancy'> {
    acf: {
      hero_intro?: string
      hero_subtitle?: string
      buildingblocks?: Array<Acf.Block>
      title: string
      intro_text?: string
      sub_text?: string
      kind_media: 'video' | 'image' | 'none'
      image?: { 
        id: number
        sizes: { [P in PublicSiteImageSize<ExtraImages>]: string }
      }
      image_alt?: string
      video?: string
      links: Array<{
        link_title: Acf.Text
        link_url: Acf.Text
      }>
      author_name: Acf.Text
      author_job: Acf.Text
      author_image: Acf.ImageArray
    }
  }